import { Injectable } from '@angular/core';
import { AppService } from './app.service';
import { DataService } from './data.service';
import { Datasource } from './datasource';

@Injectable({
  providedIn: 'root'
})
export class TaskService {
  private dsTask: Datasource;

  //TODO:  Should this service be part of TaskOS???

  constructor(private app: AppService, private ds: DataService) {
    this.dsTask = this.ds.addNewDatasource('Task', 'NO-CACHE');
  }

  markRead(taskID: string, read: boolean = true) {
    let event = read ? 'MarkRead' : 'MarkUnread';

    const body = {
      '?xml': { '@version': '1.0' },
      ConceptOneRequest: {
        TaskProcess: {
          View: 'Full',
          Event: event,
          Task: {
            Task_ID: taskID
          }
        }
      }
    };

    this.dsTask.process({ json: 'CT2' }, body);
  }

  markUnread(taskID: string, read: boolean = true) {
    this.markRead(taskID, false);
  }
}
